import * as React from "react";
import { SVGProps } from "react";
export const PersonFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10 9.97901C9.05533 9.97901 8.26366 9.65968 7.625 9.02101C6.98633 8.38168 6.667 7.59001 6.667 6.64601C6.667 5.70134 6.98633 4.90968 7.625 4.27101C8.26366 3.63168 9.05533 3.31201 10 3.31201C10.9447 3.31201 11.7363 3.63168 12.375 4.27101C13.0137 4.90968 13.333 5.70134 13.333 6.64601C13.333 7.59001 13.0137 8.38168 12.375 9.02101C11.7363 9.65968 10.9447 9.97901 10 9.97901ZM5.021 16.667C4.535 16.667 4.12166 16.4967 3.781 16.156C3.441 15.816 3.271 15.403 3.271 14.917V14.271C3.271 13.785 3.396 13.3473 3.646 12.958C3.896 12.5693 4.22233 12.2777 4.625 12.083C5.47233 11.6803 6.35066 11.3713 7.26 11.156C8.17 10.9407 9.08333 10.833 10 10.833C10.9167 10.833 11.8333 10.9407 12.75 11.156C13.6667 11.3713 14.5417 11.6803 15.375 12.083C15.7777 12.2777 16.104 12.5693 16.354 12.958C16.604 13.3473 16.729 13.785 16.729 14.271V14.917C16.729 15.403 16.559 15.816 16.219 16.156C15.8783 16.4967 15.465 16.667 14.979 16.667H5.021Z"
            fill="currentColor"
        />
    </svg>
);
PersonFillIcon.displayName = "PersonFillIcon";
